exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-60db9009] .el-table{font-size:13px}[data-v-60db9009] .el-table .cell{line-height:14px}[data-v-60db9009] .el-pagination{padding:2px 0}[data-v-60db9009] .el-pagination .el-pagination__total{margin-right:5px;font-size:12px}[data-v-60db9009] .el-pagination .el-pager li{margin:0 1px;min-width:25px;font-size:12px}[data-v-60db9009] .el-pagination .btn-next,[data-v-60db9009] .el-pagination .btn-prev{margin:0 1px;min-width:25px}", ""]);

// exports
